export const b64urlenc = (bytes) => {
    const bin = String.fromCharCode(...new Uint8Array(bytes));
    const b64 = btoa(bin);
    return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
};
